module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "justify-center pa-5"
  }, [_c('v-card', {
    attrs: {
      "loading": _vm.isLoading,
      "height": "height"
    }
  }, [_c('v-card-title', {
    staticClass: "justify-center",
    attrs: {
      "primary-title": ""
    }
  }, [_c('h3', {
    staticClass: "headline mb-1 mt-2 ml-2"
  }, [_vm._v("Audience Info")])]), _vm._v(" "), _c('v-card-text', [(!_vm.isLoading) ? _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    staticClass: "pb-3",
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Name",
      "value": _vm.audience.display_name
    }
  })], 1), _vm._v(" "), (!_vm.showVideoampMetadata) ? _c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Advertiser",
      "value": _vm.advertiserName
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pb-3",
    attrs: {
      "justify": "space-around"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [(
    !_vm.hasDigitalDestinations &&
    !_vm.showForesiteMetadata &&
    !_vm.showBroadcastQuarter &&
    !(_vm.isDigitalTarget && _vm.isWorkingStatus) &&
    !_vm.showVideoampMetadata
  ) ? _c('v-row', {
    staticClass: "pa-3 pb-0"
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Viewing Stream",
      "value": _vm.viewingStream
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasDigitalDestinations) ? _c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [(_vm.isLiveStatus) ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Refresh Frequency",
      "value": _vm.frequency
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isLiveStatus) ? _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Refresh Day",
      "value": _vm.exportDayOfWeek
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showForesiteMetadata || _vm.showBroadcastQuarter) ? _c('v-row', {
    attrs: {
      "justify": "start"
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Viewing Stream",
      "value": _vm.viewingStream
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Broadcast Quarter",
      "value": _vm.broadcastQuarter
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Demo Qualifier",
      "value": _vm.demoQualifier
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isFlightDatesNotNull) ? _c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Flight Start",
      "value": _vm.flightStartDate
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-0",
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "Flight End",
      "value": _vm.flightEndDate
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLasActivatedAndNoUE || _vm.showMrmId) ? _c('v-row', {
    staticClass: "pt-3 pb-3",
    attrs: {
      "justify": "space-between"
    }
  }, [(_vm.isLasActivatedAndNoUE) ? _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "UE",
      "rules": _vm.UERules,
      "readonly": !_vm.hasPublishPermissions
    },
    model: {
      value: (_vm.universeEstimate),
      callback: function($$v) {
        _vm.universeEstimate = $$v
      },
      expression: "universeEstimate"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMrmId) ? _c('v-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "MRM ID",
      "rules": _vm.mrmIdRules,
      "readonly": !_vm.hasPublishPermissions
    },
    model: {
      value: (_vm.mrmId),
      callback: function($$v) {
        _vm.mrmId = $$v
      },
      expression: "mrmId"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showForesiteMetadata) ? [_c('v-row', {
    staticClass: "pa-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-text-field', {
    attrs: {
      "filled": "",
      "readonly": "",
      "dense": "",
      "hide-details": "auto",
      "label": "File Name",
      "value": _vm.foresiteMetadata.pid_file_name
    }
  })], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('campaign-quarter-select', {
    attrs: {
      "initialValue": _vm.foresiteMetadata.campaign_quarter,
      "readonly": _vm.hasLake5Destination
    },
    on: {
      "updatedCampaignQuarter": function (val) { return (_vm.foresiteMetadata.campaign_quarter = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.campaignQuarterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Qtr Matched To",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.foresiteMetadata.quarter_matched_to),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "quarter_matched_to", $$v)
      },
      expression: "foresiteMetadata.quarter_matched_to"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.campaignQuarterOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Flight From",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.foresiteMetadata.flight_from),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "flight_from", $$v)
      },
      expression: "foresiteMetadata.flight_from"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.flightToOptions,
      "item-text": "name",
      "item-value": "value",
      "label": "Flight To",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "disabled": !_vm.foresiteMetadata.flight_from,
      "hide-details": "auto",
      "dense": ""
    },
    on: {
      "input": function (val) { return _vm.$emit('input', val); }
    },
    model: {
      value: (_vm.foresiteMetadata.flight_to),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "flight_to", $$v)
      },
      expression: "foresiteMetadata.flight_to"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "9"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "label": "Lake5 Name"
    },
    model: {
      value: (_vm.foresiteMetadata.lake5_name),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "lake5_name", $$v)
      },
      expression: "foresiteMetadata.lake5_name"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('demo-id', {
    attrs: {
      "initialValue": _vm.foresiteMetadata.demo_id,
      "readonly": _vm.hasLake5Destination || _vm.hasDemoId || !_vm.hasPublishPermissions
    },
    on: {
      "updatedDemoId": function (val) { return (_vm.foresiteMetadata.demo_id = val); }
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-3 pb-0",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-textarea', {
    attrs: {
      "dense": "",
      "outlined": "",
      "readonly": _vm.hasLake5Destination || !_vm.hasPublishPermissions,
      "hide-details": "auto",
      "label": "Notes",
      "height": "90",
      "no-resize": "",
      "rules": _vm.notesRules
    },
    model: {
      value: (_vm.foresiteMetadata.lake5_notes),
      callback: function($$v) {
        _vm.$set(_vm.foresiteMetadata, "lake5_notes", $$v)
      },
      expression: "foresiteMetadata.lake5_notes"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.showVideoampMetadata) ? [_c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('campaign-quarter-select', {
    attrs: {
      "initialValue": _vm.videoampMetadata.campaign_quarter,
      "readonly": _vm.hasLake5Destination
    },
    on: {
      "updatedCampaignQuarter": function (val) { return (_vm.videoampMetadata.campaign_quarter = val); }
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination,
      "hide-details": "auto",
      "label": "Advertiser"
    },
    model: {
      value: (_vm.videoampMetadata.advertiser),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "advertiser", $$v)
      },
      expression: "videoampMetadata.advertiser"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": "",
      "hide-details": "auto",
      "label": "Currency"
    },
    model: {
      value: (_vm.videoampMetadata.currency),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "currency", $$v)
      },
      expression: "videoampMetadata.currency"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pa-0 pl-3 pr-3",
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    staticClass: "pl-0 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination,
      "hide-details": "auto",
      "label": "VideoAmp ID"
    },
    model: {
      value: (_vm.videoampMetadata.videoamp_id),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "videoamp_id", $$v)
      },
      expression: "videoampMetadata.videoamp_id"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "readonly": _vm.hasLake5Destination,
      "hide-details": "auto",
      "label": "Deal Number"
    },
    model: {
      value: (_vm.videoampMetadata.deal_number),
      callback: function($$v) {
        _vm.$set(_vm.videoampMetadata, "deal_number", $$v)
      },
      expression: "videoampMetadata.deal_number"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pl-2 pr-0",
    attrs: {
      "md": "3"
    }
  }, [_c('demo-id', {
    attrs: {
      "initialValue": _vm.videoampMetadata.demo_id,
      "readonly": _vm.hasLake5Destination
    },
    on: {
      "updatedDemoId": function (val) { return (_vm.videoampMetadata.demo_id = val); }
    }
  })], 1)], 1)] : _vm._e()], 2), _vm._v(" "), (!_vm.showDestinations) ? _c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.showDestinations) ? _c('v-col', {
    attrs: {
      "md": "6",
      "lg": "5"
    }
  }, [_c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-subheader', [_vm._v("Destinations")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "inline-flex justify-center"
  }, _vm._l((_vm.destinations), function(destination) {
    return _c('v-col', {
      key: destination.id,
      attrs: {
        "md": "3"
      }
    }, [_c('MVPD', {
      attrs: {
        "destination": destination,
        "selected": _vm.audience.destinations.includes(destination.id),
        "canUpdate": _vm.canUpdateUE(),
        "showUE": _vm.showUEHoverOver,
        "UE": _vm.getUE(destination),
        "MRM_ID": _vm.getmrmId(destination),
        "minWidth": _vm.destinationWidth,
        "showMRM_ID": false
      }
    })], 1)
  }), 1)], 1) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.isLoading && _vm.showUpdate) ? _c('v-card-actions', {
    staticClass: "justify-center pt-0 pb-7"
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.canUpdate,
      "color": "success"
    },
    on: {
      "click": _vm.updateAudience
    }
  }, [_vm._v(_vm._s(_vm.buttonLabel))])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-018131d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/AudienceDetailRenderer.vue
// module id = 1792
// module chunks = 0